import ChatContainer from "../components/ChatContainer";
import React from 'react'
import {useDispatch, useSelector} from "react-redux";
const MatchPage = () =>{
    const dispatch = useDispatch()
    const user = useSelector(state => state.matchedUserReducer.users)
    return (
        <div className={'main-chat-container'}>
            { !!user &&    <ChatContainer user={user}/>}
        </div>
    )

}

export default MatchPage